import React from 'react';
import { FooterV2, Segment } from '@sparknz/journeys-common';
import { Box } from '@sparknz/spark-pattern-library';

import { VARIATION } from 'shared/constants/content.constant';
import { useSegment } from 'shared/hooks';
import { environmentVariables } from 'shared/utils/environment.utils';

function Footer() {
  const { apiURL } = environmentVariables;
  const { segment } = useSegment();

  return (
    <Box pt="s5" pb={['s2', 's3']}>
      <FooterV2 apiBaseUrl={apiURL} variation={VARIATION[segment as Segment]} />
    </Box>
  );
}

export default Footer;
